<template>
  <q-page padding class=" window-width row justify-center">
    <div class="col-12 col-sm-8">
      <q-form @submit.prevent.stop="auth">
        <q-card>
          <q-toolbar class="bg-primary text-white">
            <q-toolbar-title>Войти</q-toolbar-title>
          </q-toolbar>
          <q-card-section class="q-gutter-md">
            <q-input v-model="login" :rules="[requiredRule, loginRule]" dense square outlined
                     label="Email или телефон"/>
            <q-input v-model="password" :rules="[requiredRule]" dense square outlined type="password" label="Пароль"/>
          </q-card-section>
          <q-card-actions>
            <q-btn
                no-caps
                type="submit"
                color="primary"
                label="Войти"
                class=" form-button"
            />
            <q-btn
                no-caps
                to="/register"
                label="Зарегистрироваться"
                color="primary" flat
            />
          </q-card-actions>
          <q-card-actions class="q-gutter-sm">
            <router-link to="/reset" class="text-subtitle2">Забыли пароль?</router-link>
          </q-card-actions>
        </q-card>
      </q-form>

    </div>
  </q-page>
</template>

<script setup lang="ts">
import {ref} from "vue"
import {requiredRule, loginRule} from "../util/rules"
import {useRoute, useRouter} from "vue-router"
import {useUserStore} from "../store/user"

const store = useUserStore()

const login = ref("")
const password = ref("")

const router = useRouter()
const route = useRoute()

function resolveReturnPath() {
  const value = route.query.returnTo
  const returnTo = Array.isArray(value) ? value[0] : value
  if (typeof returnTo !== "string") {
    return "/"
  }
  if (!returnTo.startsWith("/") || returnTo.startsWith("//") || returnTo.startsWith("/login")) {
    return "/"
  }
  return returnTo
}

async function auth() {
  const success = await store.auth(login.value, password.value)
  if (success) {
    await router.push(resolveReturnPath())
  }
}
</script>

<style scoped>

</style>
